<div class="_statistic-component">

	<div class="_statistic-header">
		<div>
			<p class="_title" [translate]="title"></p>
			<ng-container *ngIf="subtitle">
				<p class="_subtitle" >{{subtitle}}</p>
			</ng-container>
		</div>
		<ion-icon *ngIf="explanation" src="./assets/icons/info-outline.svg" tooltip="{{explanation | translate}}" [options]="{ 'hide-delay': 0, theme: 'light'}"></ion-icon>
	</div>

	<div *ngIf="statistic && !isLoading" class="_chart-container">
		<chart-component [data]="statistic.datasets" [labels]="statistic.labels" [chartType]="chartType" [options]="options" [canToggleLegend]="canToggleLegend" [canToggleLegendItems]="canToggleLegendItems"></chart-component>
	</div>

	<div *ngIf="isLoading"  class="_message-container">
		<div class="_loading">
			<ion-spinner name="circles"></ion-spinner>
			<p [translate]="'LOADING'"></p>
		</div>
	</div>

	<div *ngIf="isErrored"  class="_message-container">
		<div class="_errored">
			<ion-spinner name="circles" [paused]="true" color="danger"></ion-spinner>
			<p [translate]="'STATISTICS.ERRORED'"></p>
		</div>
	</div>

	<div *ngIf="isEmpty"  class="_message-container">
		<div class="_empty">
			<p [translate]="'STATISTICS.EMPTY'"></p>
		</div>
	</div>
        
</div>



